import React from 'react';
import { useSelector } from 'react-redux';

import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import LoadingWrapper from 'dpl/components/LoadingWrapper';

import { buyerApplicationEditQueryDefinition } from '../utils/queryDefinitions';
import BuyerApplicationQuiz from './BuyerApplicationQuiz';
import BuyerApplicationIntroInterstice from './BuyerApplicationIntroInterstice';

export default function BuyerApplicationLayout() {
  const breederProfileId = useSelector(({ server }) => server.breederProfileId);
  const {
    value: buyerApplicationData,
    isFetching: buyerApplicationIsFetching
  } = useResourceQuery(buyerApplicationEditQueryDefinition(breederProfileId));

  const { isFetching: currentUserIsFetching } = useCurrentUser();

  return (
    <LoadingWrapper
      className="vh-100 bg-white"
      isLoading={currentUserIsFetching || buyerApplicationIsFetching}
    >
      {buyerApplicationData.buyer_application?.quiz_submission_id ? (
        <BuyerApplicationQuiz />
      ) : (
        <BuyerApplicationIntroInterstice />
      )}
    </LoadingWrapper>
  );
}
